module.exports = __webpack_public_path__ + "img/Boat-blue.9b34f521.svg";